import React, {ReactNode, ReactElement, useRef, useState} from 'react';
import {useFontSizeAdjust} from 'ui/effects/useFontSizeAdjust';
import {useMount} from 'ui/effects/useMount';
import {lazy} from 'shared/utils/lazy';
import {Container, Inner} from './style';

interface DynamicFontSizeProps {
  children?: ReactNode;
}

export const DynamicFontSize = ({children}: DynamicFontSizeProps): ReactElement => {
  const wrapper = useRef();
  const text = useRef();
  useFontSizeAdjust(wrapper.current, text.current);

  /**
   ** Rerender is required to instantly update refs,
   ** unless the component won't correctly calculate font-size as start,
   ** and user will see a quick font-size flash
   */
  const [mounted, setMounted] = useState(false);
  useMount(lazy(setMounted, true));

  return (
    <Container ref={wrapper} data-mounted={mounted}>
      <Inner ref={text}>{children}</Inner>
    </Container>
  );
};
